// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".forum_slider_module-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 15px; }\n  .forum_slider_module-layout .container-forum-card-slider {\n    width: calc(100% - 20px) !important; }\n", ""]);
// Exports
module.exports = exports;
